(function () {
  'use strict';

  let axeptioInitialized = false;

  function callWhenWindowFnExists(fnName, callback, opts) {
    const options = opts || {};
    const tries = typeof options.tries === 'number' ? options.tries : 10;
    const delayMs = typeof options.delayMs === 'number' ? options.delayMs : 250;

    let attempt = 0;
    const tick = () => {
      const fn = window[fnName];
      if (typeof fn === 'function') {
        callback(fn);
        return;
      }
      attempt += 1;
      if (attempt >= tries) {
        console.warn(`[axeptio-custom] window.${fnName} not available after ${tries} tries`);
        return;
      }
      setTimeout(tick, delayMs);
    };
    tick();
  }

  function axeptioGetSavedConsent() {
    const cookies = document.cookie.split(';');
    const consentCookie = cookies.find(cookie => cookie.includes('axeptio_consent__custom'));
    if (consentCookie) {
      try {
        const cookieValue = consentCookie.split('=')[1];
        if (!cookieValue) return false;

        const consent = JSON.parse(decodeURIComponent(cookieValue));
        // Validate cookie structure
        if (consent && consent.consentId && consent.date && consent.expiresAt) {
          return consent;
        }
      } catch (e) {
        console.error('Error parsing axeptio consent cookie:', e);
        // If cookie is malformed, delete it
        document.cookie = `axeptio_consent__custom=; path=/; max-age=0;`;
      }
    }
    return false;
  }

  function axeptioSetSavedConsent(payload) {
    const existing = axeptioGetSavedConsent();
    if (existing) {
      document.cookie = `axeptio_consent__custom=; path=/; max-age=0;`;
    }

    const consent = payload.consent;
    if (!consent || !consent.consentId) {
      console.error('Invalid consent payload:', payload);
      return;
    }

    const now = new Date();
    const maxAgeInSeconds = 15768000; // 6 months
    const expirationDate = new Date(now.getTime() + maxAgeInSeconds * 1000);

    const cookie = {
      consentId: consent.consentId,
      date: now.toISOString(),
      expiresAt: expirationDate.toISOString()
    };
    document.cookie = `axeptio_consent__custom=${encodeURIComponent(JSON.stringify(cookie))}; path=/; max-age=${maxAgeInSeconds};`;

    // After saving, trigger validation to hide widget
    axeptioCheckCookieAge();
  }

  function axeptioCheckCookieAge() {
    const savedConsent = axeptioGetSavedConsent();
    if (!savedConsent) {
      // No cookie exists, widget should be visible (do nothing)
      return;
    }

    const expirationDate = new Date(savedConsent.expiresAt);
    const now = new Date();

    // Check if expiration date is valid
    if (isNaN(expirationDate.getTime())) {
      console.error('Invalid expiration date in consent cookie, deleting it');
      document.cookie = `axeptio_consent__custom=; path=/; max-age=0;`;
      callWhenWindowFnExists('showAxeptioButton', (fn) => fn(), { tries: 10, delayMs: 250 });
      return;
    }

    console.log("Checking cookie age", now, expirationDate);
    if (now > expirationDate) {
      // Cookie has expired, delete it and show widget
      document.cookie = `axeptio_consent__custom=; path=/; max-age=0;`;
      callWhenWindowFnExists('showAxeptioButton', (fn) => fn(), { tries: 10, delayMs: 250 });
    } else {
      // Cookie hasn't expired, hide widget
      callWhenWindowFnExists('hideAxeptioButton', (fn) => fn(), { tries: 10, delayMs: 250 });
    }
  }

  function axeptioSetupWithSDK(SDK) {
    if (axeptioInitialized) return;
    axeptioInitialized = true;

    SDK.on('consent:saved', axeptioSetSavedConsent);

    // Check cookie age on init
    axeptioCheckCookieAge();
  }

  function axeptioCustomInit(retryCount = 0) {
    const SDK = window.axeptioSDK;
    if (!SDK) {
      if (retryCount < 5) {
        // Retry up to 5 times
        setTimeout(() => {
          axeptioCustomInit(retryCount + 1);
        }, 500);
        return;
      }
      console.error('Axeptio SDK not found after 5 attempts');
      return;
    }

    if (SDK.isReady === true) {
      axeptioSetupWithSDK(SDK);
      return;
    }

    // SDK present but not ready yet: wait for ready event
    SDK.on('ready', () => axeptioSetupWithSDK(SDK));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', axeptioCustomInit);
  } else {
    // DOM is already ready, execute immediately
    axeptioCustomInit();
  }
})();